// stores/location.js
import { defineStore } from "pinia"
import { ref } from "vue"

export const useLocationStore = defineStore("location", () => {
  const permissionStatus = ref("prompt") // 'granted', 'denied', 'prompt'
  const permissionError = ref(null)

  return {
    permissionStatus,
    permissionError,
  }
})
